import { useQuery, UseQueryOptions } from '@lumapps/base-api/react-query';

import { folksonomyQueryKeys, SuggestAPIParams, suggestTag } from '../api';

export const useSuggestTagzQuery = (params: SuggestAPIParams, options?: UseQueryOptions) => {
    return useQuery({
        ...options,
        queryKey: folksonomyQueryKeys.suggestTagz(params),
        queryFn: ({ signal }) => suggestTag(params, signal),
        select: (data) => data.data || [],
    });
};
